exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".index-page .l-scroll .l-scroll-content{background:none}", ""]);

// exports
